import React from "react";

//大數轉成可讀格式
export function formatNumber(num) {
if (num === null || num === undefined) return '';
  
  if (num >= 1e12) return (num / 1e12).toFixed(1).replace(/\.0$/, '') + 'T'; // 兆
  if (num >= 1e9) return (num / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';  // 十億
  if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';  // 百萬
  if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';  // 千
  
  return num.toString();
}
